import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
//----------------------------------------------
import { ReactiveComponent } from 'src/app/components/shared/reactive-component';
import {
  ClearSearchDinersResult,
  GetDiners
} from '../../store/diners/diners.action';
import {
  AssignGuestMealPlan,
  CancelTicket
} from '../../store/tickets/tickets.action';
import { Diner } from '../../models';
import { NfcReaderService } from '../../services/nfc-reader/nfc-reader.service';
import { DinersSelectors } from '../../store/diners/diners.selectors';
import { TicketsStateSelectors } from '../../store/tickets/tickets.selectors';
import { MealPlanTicketInfo } from '../../store/utils.selectors';

export interface SelectResidentForGuestBillingModalProps {
  cancelTicketOnClose?: boolean;
  residentsOnly?: boolean;
}

@Component({
  selector: 'pos-select-resident-for-guest-billing-modal',
  templateUrl: './select-resident-for-guest-billing.modal.html',
  styleUrls: ['./select-resident-for-guest-billing.modal.scss']
})
export class SelectResidentForGuestBillingModal
  extends ReactiveComponent
  implements OnDestroy
{
  @Input() cancelTicketOnClose = true;
  @Input() residentsOnly = false;

  @ViewSelectSnapshot(TicketsStateSelectors.getMealPlanTicketInfo)
  readonly mealPlanTicketInfo: MealPlanTicketInfo;

  @Select(DinersSelectors.filteredDiners) readonly diners$: Observable<Diner[]>;

  searchQuery: string;
  isSearchingDiner = false;
  visitingFacilityId: number;
  private isSearchingByBarcode: boolean;

  constructor(
    private readonly modalController: ModalController,
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly nfcService: NfcReaderService
  ) {
    super();
  }

  *onSubscribe() {
    yield this.actions$
      .pipe(ofActionCompleted(GetDiners, ClearSearchDinersResult))
      .subscribe(() => (this.isSearchingDiner = false));
  }

  searchingDiners(event: Event): void {
    this.isSearchingDiner = true;
    if (this.isSearchingByBarcode) {
      this.isSearchingByBarcode = false;
      return;
    }
    this.searchQuery =
      (event as CustomEvent<{ value: string }>).detail.value || '';
    //this is cheat to prevent the ionChange call two times
    if (!this.searchQuery || !this.searchQuery.length) {
      this.store.dispatch(new ClearSearchDinersResult());
    }

    if (
      !this.searchQuery ||
      event.defaultPrevented ||
      this.searchQuery.length <= 2
    ) {
      this.isSearchingDiner = false;
      return;
    }

    event.preventDefault();
    this.store.dispatch(
      new GetDiners({
        name: this.searchQuery,
        patients_only: this.residentsOnly,
        visiting_facility_id: this.visitingFacilityId
      })
    );
  }

  onResidentSelected(diner: Diner) {
    this.store
      .dispatch(
        new AssignGuestMealPlan(
          this.store.selectSnapshot(TicketsStateSelectors.selectedTicketId),
          diner.id
        )
      )
      .subscribe(() => this.modalController.dismiss());
  }

  onCloseModal() {
    if (this.cancelTicketOnClose) {
      this.store.dispatch(new CancelTicket());
    }
    this.modalController.dismiss();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.store.dispatch(new ClearSearchDinersResult());
  }
}
